import React from 'react'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

export interface BackToPiloteButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const BackToPiloteButton = React.forwardRef<HTMLButtonElement, BackToPiloteButtonProps>(
  ({ className, ...props }, ref) => (
    <button
      type="button"
      className={cn('group flex h-10 w-10 items-center justify-center bg-gray-800', className)}
      ref={ref}
      {...props}>
      <Icons.arrowCircleLeft className="size-5 fill-orange-300 group-hover:fill-orange-500" />
    </button>
  )
)
